import { render } from "./ReferPerson.vue?vue&type=template&id=2ed94b81"
import script from "./ReferPerson.vue?vue&type=script&lang=js"
export * from "./ReferPerson.vue?vue&type=script&lang=js"

import "./ReferPerson.vue?vue&type=style&index=0&id=2ed94b81&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__